<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="tasks"
    :sort-by="sortBy"
    :sort-desc="false"
    :footer-props="footerProps"
  >
    <template v-slot:item.date_from="{ item }">
      {{ item.date_from | dateFormat }}
    </template>
    <template v-slot:item.expenses="{ item }">
      {{ item.expenses | priceFormat }}
    </template>
    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
    <template v-slot:body.append="{ headers }">
      <tr>
        <td
          class="text-left text-body-1 font-weight-bold"
          :colspan="headers.length - 3"
        >
          {{ $t('EREPORTER.TOTAL') }}:
        </td>
        <td class="text-left text-body-1 font-weight-bold" colspan="3">
          {{ totalDuration }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex';
import { dateFormat, priceFormat } from '@/modules/_global/filters';

export default {
  name: 'PayrollsTaskList',

  filters: {
    dateFormat,
    priceFormat
  },

  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    totalDuration: {
      type: [String, Number],
      default: 0
    }
  },

  data: () => ({
    options: {},
    sortBy: 'date',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    ...mapState(['loading']),
    headers() {
      return [
        {
          text: this.$t('ITEM.DATE'),
          sortable: true,
          value: 'date_from'
        },
        {
          text: this.$t('SERVICES.ITEM'),
          sortable: true,
          value: 'service'
        },
        {
          text: this.$t('EREPORTER.CUSTOMER'),
          sortable: true,
          value: 'customer'
        },
        {
          text: this.$t('ITEM.DURATION'),
          sortable: true,
          value: 'duration'
        },
        {
          text: this.$t('EREPORTER.PAYROLLS.NOTES'),
          sortable: true,
          value: 'notes'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  }
};
</script>
